import { Link, createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';
import { Card, ErrorState, Skeleton } from '@mkcore/ui';
import logo from '@mkcore/ui/assets/MKC-logo-secondary.png';
import { Markdown } from '@/components/markdown';

/** The privacy statement of the portal (CO-0665): public, the text is a template MKC edits on the admin page. */
export const Route = createFileRoute('/portal/privacy')({
  component: PortalPrivacy,
});

function PortalPrivacy() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language?.startsWith('en') ? 'en' : 'nl';
  const q = useQuery({
    queryKey: ['portal-privacy', lang],
    queryFn: async () => {
      const res = await fetch(`/api/v1/portal/privacy?lang=${lang}`);
      if (!res.ok) throw new Error(String(res.status));
      return (await res.json()) as { title: string; body: string };
    },
  });
  return (
    <main className="grid min-h-dvh justify-items-center bg-[var(--mkc-navy-950)] p-4 sm:py-10">
      <Card className="w-full max-w-2xl overflow-hidden">
        <div className="bg-[var(--mkc-navy-850)] px-8 py-6">
          <img src={logo} alt="MKC · Martijn Kerver Consulting" className="w-40" />
        </div>
        <div className="grid gap-4 p-6 sm:p-8">
          <Link to="/portal/login" className="flex w-fit items-center gap-1 py-1 text-sm text-fg-2 hover:underline">
            <ArrowLeft className="size-4" aria-hidden /> {t('portal.privacyBack')}
          </Link>
          {q.isError ? (
            <ErrorState title={t('portal.privacyMissing')} />
          ) : !q.data ? (
            <Skeleton className="h-64" />
          ) : (
            <article className="grid gap-3">
              <h1 className="text-2xl font-bold">{q.data.title}</h1>
              <Markdown text={q.data.body} />
            </article>
          )}
        </div>
      </Card>
    </main>
  );
}
